import { useEffect, useMemo, useState, useCallback } from "react";
import { GetAllOrder, markAsDelivered } from "../../services/orderService";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import CommonMessage from "../../common/CommonMessage";


//import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { createShipment } from "../../services/shipment";

const modules = [AllCommunityModule];

const GetOrder = () => {
    const userid = localStorage.getItem("userid");
    const [message, setMessage] = useState("");
    const [allRows, setAllRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [error, setErrors] = useState("");
    // const maskMobile = (mobile) => {
    //     if (!mobile) return "";

    //     mobile = mobile.toString();

    //     // If mobile is less than 3 digits, return as is
    //     if (mobile.length <= 3) return mobile;

    //     // Example: 9876543210 => 9876543***
    //     return `${mobile.substring(0, mobile.length - 3)}***`;
    // };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await GetAllOrder(Number(userid));
                if (
                    response?.statusCode === 200 &&
                    response?.success === true
                ) {
                    setErrors("");

                    const rows = [];

                    response.data.forEach((order) => {

                        // ================= PARENT ROW =================
                        rows.push({
                            id: order.id,
                            orderType:order.orderType,
                            dateCreated: order.dateCreated
        ? new Date(order.dateCreated).toLocaleString()
        : "",
                            firstName: order.firstName,
                            lastName: order.lastName,
                            email: order.email,
                            // mobile: order.mobile,
                            mobile: order.mobile,
                            address: order.address,
                            address2: order.address2,
                            landMark: order.landMark,
                            state: order.state,
                            city: order.city,
                            postalCode: order.postalCode,
                            servicability: order.servicability,
                            teleCaller: order.teleCaller,
                            paymentName:
                                order.payment?.name || "",

                            diseaseName:
                                order.issueDisease?.name || "",

                            discount: order.discount,
                            shiping: order.shiping,
                            gTotal: order.gTotal,

                            rowId: `parent-${order.id}`,

                            type: "parent",

                            hasChildren:
                                order.getOrderItemDtos?.length > 0,
                        });

                        // ================= CHILD ROW =================
                        order.getOrderItemDtos?.forEach(
                            (item, index) => {
                                rows.push({
                                    id: item.id,

                                    productName:
                                        item.productName,

                                    quantity:
                                        item.quantity,

                                    priceAtPurchase:
                                        item.priceAtPurchase,

                                    rowId: `child-${order.id}-${index}`,

                                    parentId: order.id,

                                    type: "child",
                                });
                            }
                        );
                    });

                    setAllRows(rows);
                } else {
                    setErrors(
                        response?.message ||
                        "Something went wrong"
                    );
                }
            } catch (error) {
                console.log(error);

                setErrors(
                    error.message ||
                    "Something went wrong"
                );
            }
        };

        fetchData();
    }, [userid]);

    // Expand / Collapse
    const toggleExpand = useCallback((id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    }, []);

    // Visible Rows
    const rowData = useMemo(() => {
        return allRows.filter((row) => {
            if (row.type === "parent") return true;

            return expandedRows[row.parentId];
        });
    }, [allRows, expandedRows]);

    // Expand Button Renderer
    const ExpandCell = useCallback(
        (props) => {
            const row = props.data;

            if (
                row.type === "child" ||
                !row.hasChildren
            ) {
                return null;
            }

            return (
                <button
                    onClick={() =>
                        toggleExpand(row.id)
                    }
                    style={{
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                        fontSize: "14px",
                        fontWeight: "bold",
                    }}
                >
                    {expandedRows[row.id]
                        ? "−"
                        : "+"}
                </button>
            );
        },
        [expandedRows, toggleExpand]
    );
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const RadioCellRenderer = useCallback(
        (props) => {
            const row = props.data;

            if (row.type !== "parent") {
                return null;
            }

            return (
                <input
                    type="radio"
                    name="orderSelection"
                    checked={selectedOrderId === row.id}
                    onChange={() =>
                        setSelectedOrderId(row.id)
                    }
                />
            );
        },
        [selectedOrderId]
    );
    const columnDefs = useMemo(
        () => [
            {
                headerName: "",
                width: 40,
                sortable: false,
                filter: false,
                pinned: "left",
                cellRenderer: RadioCellRenderer,
            },
            {
                headerName: "",
                width: 40,
                cellRenderer: ExpandCell,
                sortable: false,
                filter: false,
            },

            {
                field: "id",
                headerName: "ID",
                width: 50,
            },
            { field: "orderType", headerName: "Order Type" },
{
        field: "dateCreated",
        headerName: "Date Created",
      },
            {
                field: "firstName",
                headerName: "Customer Name",
                width: 120,

                valueGetter: (params) => {
                    if (
                        params.data.type ===
                        "parent"
                    ) {
                        return `${params.data.firstName} ${params.data.lastName}`;
                    }

                    return "Order Item";
                },

                cellStyle: (params) => ({
                    paddingLeft:
                        params.data.type ===
                            "child"
                            ? "40px"
                            : "10px",

                    fontWeight:
                        params.data.type ===
                            "parent"
                            ? "bold"
                            : "normal",
                }),
            },

            {
                field: "email",
                headerName: "Email",
                //flex: 1,
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.email
                        : "",
            },

            {
                field: "mobile",
                headerName: "Mobile",
                width: 140,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.mobile
                        : "",
            },

            {
                field: "address",
                headerName: "Address",
                //flex: 1,
                width: 200,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.address
                        : "",
            },
            {
                field: "state",
                headerName: "State",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.state
                        : "",
            },
            {
                field: "city",
                headerName: "City",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.city
                        : "",
            },

            {
                field: "postalCode",
                headerName: "Pincode",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.postalCode
                        : "",
            },
            {
                field: "servicability",
                headerName: "Servicability",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.servicability
                        : "",
            },

            {
                field: "paymentName",
                headerName: "Payment",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.paymentName
                        : "",
            },
            {
                field: "Tele Name",
                headerName: "teleCaller",
                width: 130,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.teleCaller
                        : "",
            },

            {
                field: "diseaseName",
                headerName: "Disease",
                width: 170,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.diseaseName
                        : "",
            },

            {
                field: "discount",
                headerName: "Discount",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.discount
                        : "",
            },

            {
                field: "shiping",
                headerName: "Shipping",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.shiping
                        : "",
            },

            {
                field: "gTotal",
                headerName: "Grand Total",
                width: 150,

                valueGetter: (params) =>
                    params.data.type ===
                        "parent"
                        ? params.data.gTotal
                        : "",
            },

            // ================= CHILD ROW DATA =================

            {
                field: "productName",
                headerName: "Product",
                width: 180,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.productName
                        : "",
            },

            {
                field: "quantity",
                headerName: "Qty",
                width: 100,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.quantity
                        : "",
            },

            {
                field: "priceAtPurchase",
                headerName: "Price",
                width: 120,

                valueGetter: (params) =>
                    params.data.type ===
                        "child"
                        ? params.data.priceAtPurchase
                        : "",
            },
        ],
        [ExpandCell, RadioCellRenderer]
    );

    const buildShipmentPayload = (orderId, courierId) => {
        const order = allRows.find(
            (x) => x.type === "parent" && x.id === orderId
        );

        if (!order) {
            return null;
        }

        const items = allRows
            .filter(
                (x) =>
                    x.type === "child" &&
                    x.parentId === orderId
            )
            .map((item) => ({
                id: item.id,
                productName: item.productName,
                qty: item.quantity,
                price: item.priceAtPurchase,
            }));

        return {
            courierMasterId: courierId,
            orderId: order.id.toString(),
            customerName: `${order.firstName} ${order.lastName}`,
            mobile: order.mobile,
            address: order.address,
            address2: order.address2 || "",
            city: order.city,
            state: order.state || "",
            pincode: order.postalCode,
            weight: 1,
            length: 1,
            width: 1,
            height: 1,
            orderAmount: order.gTotal,
            isCod:
                order.paymentName?.toLowerCase() ===
                "cod",
            itemDtos: items,
        };
    };

    const [open, setOpen] = useState(false);
    const handleAction = async (
        action,
        courierId
    ) => {
        if (!selectedOrderId) {
            alert("Please select an order");
            return;
        }

        const payload = buildShipmentPayload(
            selectedOrderId,
            courierId
        );
        console.log("Payload", payload);
        try {
            //API Call
            const response = await createShipment(payload);
            console.log(response);

            if (response?.statusCode === 200) {
                setMessage(response?.message || "Shipment generated successfully");
                setErrors("");

                setAllRows(prev =>
                    prev.filter(
                        row =>
                            row.id !== selectedOrderId &&
                            row.parentId !== selectedOrderId
                    )
                );

                setSelectedOrderId(null);
                setOpen(false);
            } else {
                setMessage(response?.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong");
        }
    };

const handleMarkAsDlvrdAction = async () => {
    if (!selectedOrderId) {
        alert("Please select an order");
        return;
    }

    try {
        const response = await markAsDelivered(selectedOrderId);

        console.log(response);

        if (response?.statusCode === 200) {
            setMessage(response?.message || "Order Delivered successfully");
            setErrors("");

            setAllRows(prev =>
                prev.filter(
                    row =>
                        row.id !== selectedOrderId &&
                        row.parentId !== selectedOrderId
                )
            );

            setSelectedOrderId(null);
            setOpen(false);
        } else {
            setMessage(response?.message || "Something went wrong");
        }
    } catch (err) {
        console.error(err);
        setMessage("Something went wrong");
    }
};


    return (
        <div className="container-fluid py-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4>Order List</h4>
            </div>
            <div className="mb-3">
                {message && <CommonMessage text={message} />}
            </div>
            <div className="position-relative">
                <button
                    className="btn btn-success"
                    onClick={() => setOpen(!open)}
                >
                    Select Action
                </button>

                {open && (
                    <ul
                        className="dropdown-menu show"
                        style={{ position: "absolute" }}
                    >
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleAction(
                                    "EKart",
                                    1
                                )}
                            >
                                EKart
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleAction(
                                    "Delhivery",
                                    2
                                )}
                            >
                                Delhivery
                            </button>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="dropdown-item"
                                onClick={() => handleAction(
                                    "SelloShip PostPaid",
                                    3
                                )}
                            >
                                SelloShip PostPaid
                            </button>
                        </li>

                        <li>
                            <button
    type="button"
    className="dropdown-item"
    onClick={() => handleMarkAsDlvrdAction()}
>
    Mark as Delivered
</button>
                        </li>

                    </ul>
                )}
            </div>
            <div
                className="ag-theme-quartz"
                style={{
                    width: "100%",
                }}
            >
                <AgGridReact
                    modules={modules}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    pagination={true}
                    paginationPageSize={10}
                    rowHeight={45}
                    animateRows={true}
                    domLayout="autoHeight"
                    getRowId={(params) =>
                        params.data.rowId
                    }

                    getRowStyle={(params) => {
                        if (params.data.type === "child") {
                            return {
                                background: "#f8f9fa",
                            };
                        }
                    }}
                />
            </div>

            {error && <CommonMessage text={error} />}
        </div>
    );
};

export default GetOrder;